<div class="alert alert-info" *ngIf="!exibeListagem()">Não foi encontrada renúncia com o filtro informado.</div>

<div class="table-responsive" *ngIf="exibeListagem()">
  <table class="table table-hover">
    <thead>
      <tr>
        <th>
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeAgenteFinanceiro'"
            [nomeAtributoExibicao]="'Agente Financeiro'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
        </th>
        <th>
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeLimiteAdicional'"
            [nomeAtributoExibicao]="'Limite Adicional'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
        </th>
        <th class="text-center">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataSolicitacao'"
            [nomeAtributoExibicao]="'Dt. Solicitação'" (aoClickar)="mudancaOrdenacao($event)"
            ngbTooltip="Data/hora da solicitação da Renúncia"></bn-ordenacao>
        </th>
        <th class="text-center">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'usuarioResponsavel'"
            [nomeAtributoExibicao]="'Usuário Responsável'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
        </th>
        <th class="text-center">Janela de Renúncia</th>
        <th class="text-center">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'habilitacaoFaixaPj'"
            [nomeAtributoExibicao]="'Faixa Carteira Inferior'" (aoClickar)="mudancaOrdenacao($event)"
            ngbTooltip="Habilitação em Faixa de Carteira PJ inferior no IF.Data"></bn-ordenacao>
        </th>
        <th class="text-center">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'renunciaTotal'"
            [nomeAtributoExibicao]="'Renúncia Total'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
        </th>
        <th class="text-center">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorParcial'"
            [nomeAtributoExibicao]="'Valor Parcial R$'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
        </th>
        <th class="text-center">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'percentualParcial'"
            [nomeAtributoExibicao]="'Percentual %'" (aoClickar)="mudancaOrdenacao($event)"></bn-ordenacao>
        </th>

        <th class="text-center" id="col-acoes" *ngIf="exibeColunaAcoes()">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let renuncia of renuncias">
        <td>{{ renuncia?.nomeAgenteFinanceiro }}</td>
        <td>{{ renuncia?.nomeLimiteAdicional }}</td>
        <td class="text-center">{{ renuncia?.dataSolicitacao | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td class="text-center">{{ renuncia?.usuarioResponsavel }}</td>
        <td class="text-center">
          <i class="fa fa-calendar cursor-pointer" *ngIf="renuncia?.janelaInicio"
            ngbTooltip="{{ (renuncia?.janelaInicio | date: 'dd/MM/yyyy') }} a {{ (renuncia?.janelaFim | date: 'dd/MM/yyyy') }}"></i>
        </td>
        <td class="text-center">{{ renuncia?.habilitacaoFaixaPj ? 'Sim' : 'Não' }}</td>
        <td class="text-center">{{ renuncia?.renunciaTotal ? 'Sim' : 'Não' }}</td>
        <td class="text-center">{{ renuncia?.valorParcial | bnMask: 'MOEDA' }}</td>
        <td class="text-center">{{ renuncia?.percentualParcial != null ? ((renuncia?.percentualParcial | number: '1.2-2') + ' %') : '' }}</td>

        <td class="text-center acoes" *ngIf="exibeColunaAcoes()">
          <a href="javascript:void(0)" *ngIf="podeExcluir(renuncia)"
            (click)="abrirModalConfirmarExclusao(renuncia)">
            <i class="fa fa-trash cursor-pointer"
              placement="left-top"
              ngbTooltip="Excluir a solicitação de Renúncia Limite Adicional"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #modalExclusao>
  <div class="bn-form-group row">
    <div class="col">
      <label>Confirma a exclusão da solicitação de renúncia?</label>
    </div>
  </div>
</ng-template>

<ng-template #botoesModalExclusao>
  <button class="btn btn-default" (click)="fecharModalExclusao()">Fechar</button>
  <button class="btn btn-primary" (click)="confirmarExclusao()">Confirmar</button>
</ng-template>